import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const getPortalTarget = () =>
  typeof document !== "undefined"
    ? document.querySelector(".keobongvip-root") || document.body
    : null;

const BookmakerSelectV8 = ({
  value,
  onChange,
  options,
  scopeClassName = "",
}) => {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const ref = useRef(null);
  const dropdownRef = useRef(null);

  const selected = options.find((o) => String(o.value) === String(value));

  const DROPDOWN_WIDTH = 161;

  const updatePosition = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const buttonCenterX = rect.left + rect.width / 2;
      setPosition({
        top: rect.bottom + 6,
        left: buttonCenterX - DROPDOWN_WIDTH,
      });
    }
  };

  useEffect(() => {
    if (!open) return;
    updatePosition();
    const onScrollOrResize = () => updatePosition();
    window.addEventListener("scroll", onScrollOrResize, true);
    window.addEventListener("resize", onScrollOrResize);
    requestAnimationFrame(updatePosition);
    return () => {
      window.removeEventListener("scroll", onScrollOrResize, true);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, [open]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      const wrapper = ref.current;
      const dropdown = dropdownRef.current;
      if (
        wrapper &&
        !wrapper.contains(e.target) &&
        dropdown &&
        !dropdown.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (val) => {
    onChange(val);
    setOpen(false);
  };

  const dropdown = open && (
    <div
      ref={dropdownRef}
      className={`kbv-bookmaker-select-v8-portal ${scopeClassName}`}
      style={{
        position: "fixed",
        top: position.top,
        left: position.left,
        width: DROPDOWN_WIDTH,
        zIndex: 99999,
      }}
    >
      <ul className="m-0 list-none w-[161px] rounded-xl kbv-bg-white p-2.5 kbv-shadow-main">
        {options.map((item) => (
          <li
            key={item.value}
            className="flex flex-row items-center mb-2.5 cursor-pointer border-b kbv-border-lighter pb-2.5 text-base font-medium text-black last:mb-0"
            onClick={() => handleSelect(item.value)}
          >
            <span className="pl-[17px]">{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );

  const portalTarget = getPortalTarget();

  return (
    <>
      <button
        type="button"
        ref={ref}
        className="flex h-10 min-w-20 items-center justify-center rounded-xl border px-3 text-sm font-normal leading-none kbv-border-lighter kbv-bg-white kbv-text-gray kbv-shadow-main max-[1056px]:h-[29px] max-[1056px]:py-1"
        onClick={() => setOpen((prev) => !prev)}
      >
        {selected ? selected.label : ""}
      </button>
      {portalTarget && createPortal(dropdown, portalTarget)}
    </>
  );
};

export default BookmakerSelectV8;

